export default "__VITE_ASSET__BbBIlmny__"